"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyProgram = exports.LoyaltyProgramConfig = exports.LoyaltyProgramId = exports.LoyaltyProgramType = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const entity_1 = require("../../entity");
exports.NAMESPACE = 'Culligan.User.Loyalty';
exports.LoyaltyProgramType = effect_1.Schema.Enums({
    /** Get points per each drink dispensed */
    PointsPerDrink: 'pointsPerDrink',
    /** Get points based on the volume of drinks dispensed */
    PointsPerVolume: 'pointsPerVolume',
}).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyProgramType`,
    description: 'Each type of loyalty program has a different way of calculating points.',
});
exports.LoyaltyProgramId = effect_1.Schema.NonEmptyString.pipe(effect_1.Schema.pattern(/^[a-zA-Z0-9]+$/)).annotations({
    description: 'An automatically-generated unique identifier (ID)',
    identifier: `${exports.NAMESPACE}.LoyaltyProgramId`,
});
exports.LoyaltyProgramConfig = effect_1.Schema.Struct({
    type: exports.LoyaltyProgramType,
    value: effect_1.Schema.Positive,
}).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyProgramConfig`,
});
exports.LoyaltyProgram = effect_1.Schema.extend(entity_1.BaseTimestampedEntity, effect_1.Schema.Struct({
    id: effect_1.Schema.NonEmptyString,
    name: effect_1.Schema.String,
    enabled: effect_1.Schema.Boolean,
    config: exports.LoyaltyProgramConfig,
})).annotations({
    identifier: `${exports.NAMESPACE}.LoyaltyProgram`,
    description: 'Loyalty program configuration for a specific machine or group of machines',
});
//# sourceMappingURL=loyalty.js.map